import React from 'react';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';

const ExitFullScreenIcon = () => {
  return <CloseFullscreenIcon fontSize="small" />;
};

export default ExitFullScreenIcon;
